export default __webpack_public_path__ + "static/media/scrollGreen.0f024ede.svg";